const classList = state => state.classList;
const statistics = state => state.statistics;
const subject = state => state.subject;
const question = state => state.question;
const questionIndex = state => state.questionIndex;
const questionCorrected = state => state.questionCorrected;
const questionId = state => state.questionId;
const questionList = state => state.questionList;
const action = state => state.action;
const isNext = state => state.isNext;
const isPrev = state => state.isPrev;

export default {
  classList,
  statistics,
  subject,
  question,
  questionIndex,
  questionCorrected,
  questionId,
  questionList,
  action,
  isNext,
  isPrev
};